import { createAction } from 'signin-app/redux/helpers';
const domain = 'MODALS/DISPLAYED_GROUPS_SETTINGS';
export const { action: show } = createAction(`${domain}/SHOW`, () => ({}));
export const { action: hide } = createAction(`${domain}/HIDE`, () => ({}));
